// import React, { useState } from 'react';
// import './purchaseFlow.css';
// import { Box, Container, Typography } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

// const ProductPurchaseFlow = () => {
//   const [activeStep, setActiveStep] = useState(1);

//   const steps = [
//     {
//       number: 1,
//       title: "ORDER & PAYMENT",
//       subtitle: "Reserve Your Vehicle & Complete Payment",
//       content: {
//         main: "Search for a vehicle you would like to purchase.",
//         options: [
//           {
//             title: "Using “Buy Now”",
//             description: "Instantly reserve and buy the vehicle. After placing an order with \"Buy Now\", you can pay via bank transfer using the Proforma Invoice."
//           },
//           {
//             title: "Using “Get a Price Quote”",
//             description: "Receive a price quotation by email. If satisfied, we'll prepare your Proforma Invoice for payment."
//           },
//           {
//             title: "Contact Local Offices",
//             description: "Visit our local offices or agents for personalized assistance with your purchase."
//           }
//         ],
//         payment: {
//           title: "Complete Your Payment",
//           description: "Make payment to our bank account and email the receipt to complete your order.",
//           methods: [
//             "Bank Transfer to our company account",
//             "Submit payment receipt via email",
//             "Payment confirmation within 24 hours"
//           ]
//         }
//       }
//     },
//     {
//       number: 2,
//       title: "SHIPMENT",
//       subtitle: "Vehicle Preparation & Shipping",
//       content: {
//         main: "When payment is confirmed, we begin the shipping process.",
//         features: [
//           "Receive shipping schedule and updates",
//           "Original documents prepared for customs",
//           "Bill of Lading delivered by Logistic Partner",
//           "Track your vehicle in my account"
//         ]
//       }
//     },
//     {
//       number: 3,
//       title: "DELIVERY",
//       subtitle: "Receive Your Vehicle",
//       content: {
//         main: "Your vehicle arrives at the agreed destination.",
//         features: [
//           "Clear customs with required documents",
//           "Optional City Delivery Service available",
//           "Professional clearing assistance",
//           "Final vehicle inspection and handover"
//         ],
//         note: "Enjoy driving your new car!"
//       }
//     }
//   ];

//   return (
//       <Box 
//         className="content-section-purchase"
//         maxWidth="lg"
//         sx={{
//           position: "relative",
//           width: "100%",
//           minHeight: "60vh",
//           margin: "0 auto", 
//         }}
//       >
//         {/* Purchase Flow */}
//         <Box id="inquiry-section" sx={{ mt: 8, mb: 12 }}>
//           <Typography
//             variant="h3"
//             sx={{
//               fontWeight: "600",
//               fontSize: { xs: "28px", sm: "32px", md: "40px" },
//               mb: 2,
//               textAlign: "center",
//             }}
//           >
//             <span style={{ color: "#eb2329" }}>Purchase</span>
//             <span style={{ color: "#000000", marginLeft: "10px" }}>Process</span>
//             <span style={{ color: "#000000", marginLeft: "10px" }}>Guide</span>
//           </Typography>

//           {/* Red underline */}
//           <Box
//             sx={{
//               width: "60px",
//               height: "3px",
//               backgroundColor: "#eb2329",
//               borderRadius: "2px",
//               mx: "auto",
//               mb: "50px"
//             }}
//           />
//         </Box>

//         <Box
//           sx={{
//             width: "100%",
//             backgroundColor: "#FFFFFF",
//             border: "2px solid red",
//             borderRadius: "15px",
//             display: "flex",
//             flexDirection: "column",
//             boxShadow: "0 10px 30px rgba(220, 38, 38, 0.1)",
//             overflow: "hidden",
//             margin: "0 auto",
//             transform: "translateY(-50px)",
//             // marginBottom: "50px",
//           }}
//         >
//           {/* Header with Gradient */}
//           {/* <Box
//             sx={{
//               background: "linear-gradient(135deg, #DC2626 0%, #1E3A8A 100%)",
//               padding: "2rem",
//               borderBottom: "3px solid #000000",
//             }}
//           >
//             <Typography
//               sx={{
//                 fontWeight: "800",
//                 fontSize: "28px",
//                 color: "#FFFFFF",
//                 textAlign: "center",
//                 textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
//               }}
//             >
//               PURCHASE PROCESS GUIDE
//             </Typography>
//           </Box> */}

//           {/* Purchase Flow Content */}
//           <Box
//             sx={{
//               width: "100%",
//               padding: "3% 8%",
//               backgroundColor: "#FFFFFF",
//             }}
//           >
//             <div className="purchase-flow">
//               {/* Navigation Controls */}
//               {/* <Box
//                 className="navigation-controls"
//                 sx={{
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   gap: 3,
//                   marginBottom: "30px",
//                   marginTop: "20px",
//                 }}
//               >
//                 <ArrowBackIosNewIcon
//                   onClick={() => setActiveStep((prev) => Math.max(1, prev - 1))}
//                   sx={{
//                     cursor: activeStep === 1 ? "not-allowed" : "pointer",
//                     color: activeStep === 1 ? "#ccc" : "#d32f2f",
//                     transition: "0.3s",
//                     "&:hover": {
//                       color: activeStep === 1 ? "#ccc" : "#b71c1c",
//                       transform: activeStep === 1 ? "none" : "scale(1.2)",
//                     },
//                   }}
//                 />

//                 <ArrowForwardIosIcon
//                   onClick={() =>
//                     setActiveStep((prev) => Math.min(steps.length, prev + 1))
//                   }
//                   sx={{
//                     cursor: activeStep === steps.length ? "not-allowed" : "pointer",
//                     color: activeStep === steps.length ? "#ccc" : "#d32f2f",
//                     transition: "0.3s",
//                     "&:hover": {
//                       color: activeStep === steps.length ? "#ccc" : "#b71c1c",
//                       transform: activeStep === steps.length ? "none" : "scale(1.2)",
//                     },
//                   }}
//                 />
//               </Box> */}

//               <div className="steps-container">
//                 <div className="steps-progress">
//                   {steps.map((step, index) => (
//                     <React.Fragment key={step.number}>
//                       <div className="step-progress-item">
//                         <div 
//                           className={`progress-circle ${activeStep >= step.number ? 'active' : ''} ${activeStep === step.number ? 'current' : ''}`}
//                           onClick={() => setActiveStep(step.number)}
//                         >
//                           <span className="step-number">{step.number}</span>
//                           <div className="pulse-ring"></div>
//                         </div>
//                         <div className="step-title">{step.title}</div>
//                       </div>
                      
//                       {/* Arrow between steps */}
//                       {index < steps.length - 1 && (
//                         <div className="step-arrow">
//                           <ArrowForwardIosIcon 
//                             sx={{ 
//                               color: activeStep > step.number ? '#d32f2f' : '#bdc3c7',
//                               fontSize: '2rem',
//                               transition: 'color 0.3s ease'
//                             }} 
//                           />
//                         </div>
//                       )}
//                     </React.Fragment>
//                   ))}
//                 </div>

//                 <div className="steps-content">
//                   {steps.map((step) => (
//                     <div 
//                       key={step.number} 
//                       className={`step-content ${activeStep === step.number ? 'active' : ''}`}
//                     >
//                       <div className="content-header">
//                         <h2 className="step-main-title">{step.title}</h2>
//                         <p className="step-subtitle">{step.subtitle}</p>
//                       </div>
                      
//                       <div className="content-body">
//                         <p className="main-description">{step.content.main}</p>
                        
//                         {step.content.options && (
//                           <div className="options-grid">
//                             {step.content.options.map((option, idx) => (
//                               <div key={idx} className="option-card">
//                                 <div className="option-icon">✓</div>
//                                 <h4>{option.title}</h4>
//                                 <p>{option.description}</p>
//                               </div>
//                             ))}
//                           </div>
//                         )}

//                         {step.content.payment && (
//                           <div className="payment-section">
//                             <div className="payment-card">
//                               <h3>{step.content.payment.title}</h3>
//                               <p>{step.content.payment.description}</p>
//                               <div className="payment-methods">
//                                 {step.content.payment.methods.map((method, idx) => (
//                                   <div key={idx} className="method-item">
//                                     <span className="method-bullet">●</span>
//                                     {method}
//                                   </div>
//                                 ))}
//                               </div>
//                             </div>
//                           </div>
//                         )}

//                         {step.content.features && (
//                           <div className="features-grid">
//                             {step.content.features.map((feature, idx) => (
//                               <div key={idx} className="feature-item">
//                                 <div className="feature-icon">→</div>
//                                 <span>{feature}</span>
//                               </div>
//                             ))}
//                           </div>
//                         )}

//                         {step.content.note && (
//                           <div className="delivery-note">
//                             <div className="note-icon">🎉</div>
//                             <p>{step.content.note}</p>
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </Box>
//         </Box>
//       </Box>
//   );
// };

// export default ProductPurchaseFlow;

import React, { useState } from 'react';
import './purchaseFlow.css';
import { Box, Container, Typography } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const ProductPurchaseFlow = () => {
  const [activeStep, setActiveStep] = useState(1);

  const steps = [
    {
      number: 1,
      title: "ORDER & PAYMENT",
      subtitle: "Reserve Your Vehicle & Complete Payment",
      content: {
        main: "Search for a vehicle you would like to purchase.",
        options: [
          {
            title: "Using “Buy Now”",
            description: "Instantly reserve and buy the vehicle. After placing an order with \"Buy Now\", you can pay via bank transfer using the Proforma Invoice."
          },
          {
            title: "Using “Get a Price Quote”",
            description: "Receive a price quotation by email. If satisfied, we'll prepare your Proforma Invoice for payment."
          },
          {
            title: "Contact Local Offices",
            description: "Visit our local offices or agents for personalized assistance with your purchase."
          }
        ],
        payment: {
          title: "Complete Your Payment",
          description: "Make payment to our bank account and email the receipt to complete your order.",
        //   methods: [
        //     "Bank Transfer to our company account",
        //     "Submit payment receipt via email",
        //     "Payment confirmation within 24 hours"
        //   ]
        }
      }
    },
    {
      number: 2,
      title: "SHIPMENT",
      subtitle: "Vehicle Preparation & Shipping",
      content: {
        main: "When payment is confirmed, we begin the shipping process.",
        features: [
          "Receive shipping schedule and updates",
          "Original documents prepared for customs",
          "Bill of Lading delivered by Logistic Partner",
          "Track your vehicle in my account"
        ]
      }
    },
    {
      number: 3,
      title: "DELIVERY",
      subtitle: "Receive Your Vehicle",
      content: {
        main: "Your vehicle arrives at the agreed destination.",
        features: [
          "Clear customs with required documents",
          "Optional City Delivery Service available",
          "Professional clearing assistance",
          "Final vehicle inspection and handover"
        ],
        note: "Enjoy driving your new car!"
      }
    }
  ];

  return (
      <Box 
        className="content-section-purchase"
        maxWidth="lg"
        sx={{
          position: "relative",
          width: "100%",
          minHeight: "60vh",
          margin: "0 auto", 
        }}
      >
        {/* Purchase Flow */}
        <Box id="inquiry-section" sx={{ mt: 8, mb: 12 }}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: "600",
              fontSize: { xs: "28px", sm: "32px", md: "40px" },
              mb: 2,
              textAlign: "center",
            }}
          >
            <span style={{ color: "#eb2329" }}>Purchase</span>
            <span style={{ color: "#000000", marginLeft: "10px" }}>Process</span>
            <span style={{ color: "#000000", marginLeft: "10px" }}>Guide</span>
          </Typography>

          {/* Red underline */}
          <Box
            sx={{
              width: "60px",
              height: "3px",
              backgroundColor: "#eb2329",
              borderRadius: "2px",
              mx: "auto",
              mb: "50px"
            }}
          />
        </Box>

        <Box
          sx={{
            width: "100%",
            backgroundColor: "#FFFFFF",
            border: "2px solid red",
            borderRadius: "15px",
            display: "flex",
            flexDirection: "column",
            boxShadow: "0 10px 30px rgba(220, 38, 38, 0.1)",
            overflow: "hidden",
            margin: "0 auto",
            transform: "translateY(-50px)",
            // marginBottom: "50px",
          }}
        >
          {/* Purchase Flow Content */}
          <Box
            sx={{
              width: "100%",
              padding: "3% 8%",
              backgroundColor: "#FFFFFF",
            }}
          >
            <div className="purchase-flow">
              <div className="steps-container">
                <div className="steps-progress">
                  {steps.map((step, index) => (
                    <React.Fragment key={step.number}>
                      <div className="step-progress-item">
                        <div 
                          className={`progress-circle ${activeStep >= step.number ? 'active' : ''} ${activeStep === step.number ? 'current' : ''}`}
                          onClick={() => setActiveStep(step.number)}
                        >
                          <span className="step-number">{step.number}</span>
                          <div className="pulse-ring"></div>
                        </div>
                        <div className="step-title">{step.title}</div>
                      </div>
                      
                      {/* Arrow between steps */}
                      {index < steps.length - 1 && (
                        <div className="step-arrow">
                          <ArrowForwardIosIcon 
                            sx={{ 
                              color: activeStep > step.number ? '#d32f2f' : '#bdc3c7',
                              fontSize: '2rem',
                              transition: 'color 0.3s ease'
                            }} 
                          />
                        </div>
                      )}
                    </React.Fragment>
                  ))}
                </div>

                <div className="steps-content">
                  {steps.map((step) => (
                    <div 
                      key={step.number} 
                      className={`step-content ${activeStep === step.number ? 'active' : ''}`}
                    >
                      <div className="content-header">
                        <h2 className="step-main-title">{step.title}</h2>
                        <p className="step-subtitle">{step.subtitle}</p>
                      </div>
                      
                      <div className="content-body">
                        <p className="main-description">{step.content.main}</p>
                        
                        {/* ------------------------------------------------------------- */}
                        {/* NEW IMPLEMENTATION for 2x2 Layout in Step 1 */}
                        {/* ------------------------------------------------------------- */}
                        {(step.content.options || step.content.payment) && step.number === 1 && (
                            <Box 
                                sx={{ 
                                    display: 'flex', 
                                    flexWrap: 'wrap', // Allows items to wrap to the next line
                                    gap: 3, // Spacing between the four sections
                                    mt: 3, // Margin-top for separation from main description
                                }}
                            >
                                {/* Render the three options as individual items */}
                                {step.content.options.map((option, idx) => (
                                    <Box 
                                        key={idx} 
                                        // On medium screens (sm) and up, each item takes ~50% of the row 
                                        // (50% minus half the gap width for proper wrap/alignment)
                                        sx={{ 
                                            flexBasis: { xs: '100%', sm: 'calc(50% - 12px)' }, 
                                            // Ensure the content fills the available Box space if needed
                                            display: 'flex', 
                                            flexDirection: 'column'
                                        }} 
                                    >
                                        {/* The original option card structure */}
                                        <div className="option-card">
                                            <div className="option-icon">✓</div>
                                            <h4>{option.title}</h4>
                                            <p>{option.description}</p>
                                        </div>
                                    </Box>
                                ))}

                                {/* Render the payment section (the 4th item) */}
                                {step.content.payment && (
                                    <Box 
                                        // This item also takes ~50% of the row on medium screens (sm) and up
                                        sx={{ 
                                            flexBasis: { xs: '100%', sm: 'calc(50% - 12px)' }, 
                                            display: 'flex', 
                                            flexDirection: 'column'
                                        }}
                                        
                                    >
                                       

                                        {/* The original payment section structure */}
                                        <div className="option-card">
                                            {/* <div> */}
                                                <div className="option-icon">✓</div>
                                                <h3>{step.content.payment.title}</h3>
                                                <p>{step.content.payment.description}</p>
                                                {/* <div className="payment-methods">
                                                    {step.content.payment.methods.map((method, idx) => (
                                                        <div key={idx} className="method-item">
                                                            <span className="method-bullet">●</span>
                                                            {method}
                                                        </div>
                                                    ))}
                                                </div> */}
                                            {/* </div> */}
                                        </div>
                                    </Box>
                                )}
                            </Box>
                        )}
                        {/* ------------------------------------------------------------- */}
                        {/* END of NEW IMPLEMENTATION for 2x2 Layout */}
                        {/* ------------------------------------------------------------- */}


                        {/* Conditional content for other steps (2 and 3) */}
                        {step.content.features && (
                          <div className="features-grid">
                            {step.content.features.map((feature, idx) => (
                              <div key={idx} className="feature-item">
                                <div className="feature-icon">→</div>
                                <span>{feature}</span>
                              </div>
                            ))}
                          </div>
                        )}

                        {step.content.note && (
                          <div className="delivery-note">
                            <div className="note-icon">🎉</div>
                            <p>{step.content.note}</p>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Box>
        </Box>
      </Box>
  );
};

export default ProductPurchaseFlow;


